import Vue from 'vue'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const setVisible4Customer = (packageId) => {
  const payload = { package: packageId }
  return Vue.$http.post('extranet/package/visible-for-customer/', payload)
    .then(response => response.data)
    .catch((err) => { throw err })
}


export default setVisible4Customer


// WEBPACK FOOTER //
// ./src/services/extranet/setVisible4Customer.js